/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Ccsl_Export_Metadata_Video_IncodeInputs */

const en_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video Incode: ${i?.timecode}`)
};

const fr_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incode video : ${i?.timecode}`)
};

const de_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video-Inkodierung: ${i?.timecode}`)
};

const it_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice video: ${i?.timecode}`)
};

const ru_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Видеокодек: ${i?.timecode}`)
};

const es_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificación de vídeo: ${i?.timecode}`)
};

const zh_cn2_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频编码：${i?.timecode}`)
};

const ja_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオインコード: ${i?.timecode}`)
};

const hi_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो इनकोड: ${i?.timecode}`)
};

const pt_pt2_ccsl_export_metadata_video_incode = /** @type {(inputs: Ccsl_Export_Metadata_Video_IncodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificação de vídeo: ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Video Incode: {timecode}" |
*
* @param {Ccsl_Export_Metadata_Video_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_video_incode = /** @type {((inputs: Ccsl_Export_Metadata_Video_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Video_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_metadata_video_incode(inputs)
	if (locale === "de") return de_ccsl_export_metadata_video_incode(inputs)
	if (locale === "it") return it_ccsl_export_metadata_video_incode(inputs)
	if (locale === "ru") return ru_ccsl_export_metadata_video_incode(inputs)
	if (locale === "es") return es_ccsl_export_metadata_video_incode(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_metadata_video_incode(inputs)
	if (locale === "ja") return ja_ccsl_export_metadata_video_incode(inputs)
	if (locale === "hi") return hi_ccsl_export_metadata_video_incode(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_metadata_video_incode(inputs)
	return en_ccsl_export_metadata_video_incode(inputs)
});